class SuggestionsController {

    constructor(markdownService) {
        this.markdownService = markdownService;
    }

    markdown (string) {
        return this.markdownService.translate(string);
    }
}

SuggestionsController.$inject = ['markdownService'];

export default SuggestionsController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/controllers/suggestions.controller.js